import { render, staticRenderFns } from "./MyHeader.vue?vue&type=template&id=4860c7d2&scoped=true&"
import script from "./MyHeader.vue?vue&type=script&lang=js&"
export * from "./MyHeader.vue?vue&type=script&lang=js&"
import style0 from "./MyHeader.vue?vue&type=style&index=0&id=4860c7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860c7d2",
  null
  
)

export default component.exports